/**
 * @generated SignedSource<<fb26efd58a18db5f879e88ccbe4c2b23>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type RoomRatesTableDateRow_groupedRate$data = {
  readonly date: {
    readonly end: string;
    readonly id: string;
    readonly start: string;
    readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_packageDate">;
  };
  readonly ratesByCatering: ReadonlyArray<{
    readonly cateringOption: {
      readonly id: string;
      readonly " $fragmentSpreads": FragmentRefs<"CateringOptionName_cateringOption" | "RoomRatesTableRateCell_cateringOption">;
    };
    readonly ratesByRoom: ReadonlyArray<{
      readonly __id: string;
      readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableRateCell_rateByRoom">;
    }>;
  }>;
  readonly " $fragmentType": "RoomRatesTableDateRow_groupedRate";
};
export type RoomRatesTableDateRow_groupedRate$key = {
  readonly " $data"?: RoomRatesTableDateRow_groupedRate$data;
  readonly " $fragmentSpreads": FragmentRefs<"RoomRatesTableDateRow_groupedRate">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "RoomRatesTableDateRow_groupedRate",
  "selections": [
    {
      "alias": null,
      "args": null,
      "concreteType": "PackageDate",
      "kind": "LinkedField",
      "name": "date",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "start",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "end",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "RoomRatesTableRateCell_packageDate"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "RateByCatering",
      "kind": "LinkedField",
      "name": "ratesByCatering",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "CateringOption",
          "kind": "LinkedField",
          "name": "cateringOption",
          "plural": false,
          "selections": [
            (v0/*: any*/),
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "CateringOptionName_cateringOption"
            },
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoomRatesTableRateCell_cateringOption"
            }
          ],
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "concreteType": "RateByRoom",
          "kind": "LinkedField",
          "name": "ratesByRoom",
          "plural": true,
          "selections": [
            {
              "args": null,
              "kind": "FragmentSpread",
              "name": "RoomRatesTableRateCell_rateByRoom"
            },
            {
              "kind": "ClientExtension",
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "__id",
                  "storageKey": null
                }
              ]
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "GroupedRate",
  "abstractKey": null
};
})();

(node as any).hash = "88b2cd051e66484e0194be0d5d0b69de";

export default node;
